import React from 'react'
import Tooltip from "@mui/material/Tooltip";
import { Chip } from "@material-ui/core";
import { useStyles } from "./styles";

const CustomChip = (props) => {
  const classes = useStyles();
  const {toolTip, className,...rest} = props 
  return (
    <Tooltip title={toolTip} arrow placement="bottom">
      <Chip className={`${classes.chipContainer} ${className}`} {...rest} />
    </Tooltip>
  );
};

export default CustomChip;
